<template>
  <div class="block block-rounded mb-4">
    <div class="block-header block-header-default">
      <h3 class="block-title">
        Upcoming Holidays
      </h3>
    </div>
    <div class="block-content">
      <p class="text-muted small mb-0">
        Upcoming holidays coming soon
      </p>
    </div>
  </div>
</template>

<script>
export default {
    name: "UpcomingHolidays",
};
</script>
